module.exports = "./img/a6f434aed1dea4f3ddd52a36d9f395cc.jpg";